import {
  Box,
  Button,
  Drawer,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  IconButton,
  Slide,
  AppBar,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Toolbar,
  Typography,
} from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation, Pagination } from "swiper";
import "swiper/swiper.scss";
import "swiper/components/navigation/navigation.scss";
import "swiper/components/pagination/pagination.scss";
import React, { useCallback, useEffect, useState, useRef } from "react";
import { makeStyles } from "@mui/styles";
import { rem } from "assets/js/common";
import LazyCDNImage from "components/utils/lazy-cdn-image";
import QuickPinchZoom, { make3dTransformValue } from "react-quick-pinch-zoom";

SwiperCore.use([Navigation, Pagination]);

const useStyles = makeStyles((theme) => ({
  ImageDrawer: {
    "& .drawer-head": {
      height: rem(74),
    },
  },
}));

export default function ImageDrawer(props) {
  const item = props.item;
  const classes = useStyles();
  const [drawerHigh, setDrawerHigh] = useState(false);
  const [imgArr, setImgArr] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [isZoom, setIsZoom] = useState(false);
  const imgRef = useRef([]);

  const slideChange = (swipe) => {
    setActiveIndex(swipe.realIndex);

    const value = make3dTransformValue({ x: 0, y: 0, scale: 1 });

    _.forEach(imgRef.current, (item, i) => {
      item.style.setProperty("transform", value);
    });
  };

  const onUpdate = useCallback(({ x, y, scale }) => {
    if (scale > 1) setIsZoom(true);
    else setIsZoom(false);

    const img = imgRef.current[activeIndex];

    if (img) {
      const value = make3dTransformValue({ x, y, scale });
      img.style.setProperty("transform", value);
    }
  });

  useEffect(() => {
    let arr = [];
    console.log("item", item);
    if (item.imgUrl1) arr.push(item.imgUrl1);
    if (item.imgUrl2) arr.push(item.imgUrl2);
    if (item.imgUrl3) arr.push(item.imgUrl3);
    console.log("item", item);
    setImgArr(arr);
  }, [item]);

  return (
    <div className={classes.ImageDrawer}>
      {imgArr.map((img, i) => (
        <span
          key={"span_" + img}
          onClick={() => {
            setDrawerHigh(true);
          }}
        >
          <LazyCDNImage
            cdnUrl={img}
            style={{ width: "60px", height: "60px" }}
          />
        </span>
      ))}

      <Drawer
        anchor="bottom"
        open={drawerHigh}
        onClose={() => {
          setDrawerHigh(false);
        }}
        className="image-drawer drawer-common-bottom size-high"
      >
        <div className="drawer-head" style={{ height: rem(74) }}>
          <IconButton
            aria-label="close"
            className="btn-close"
            onClick={() => {
              setDrawerHigh(false);
            }}
          >
            <span className="hidden">닫기</span>
          </IconButton>
        </div>

        <div className="drawer-body">
          <Swiper
            pagination={isZoom ? false : true}
            modules={[Pagination]}
            className="mySwiper"
            onSlideChange={slideChange}
          >
            {imgArr.map((img, j) => (
              <SwiperSlide key={j}>
                <QuickPinchZoom onUpdate={onUpdate} draggableUnZoomed={false}>
                  <img
                    ref={(elem) => (imgRef.current[j] = elem)}
                    src={img}
                    style={{ width: "100%" }}
                  />
                  {/* <LazyCDNImage
                    ref={(elem) => (imgRef.current[j] = elem)}
                    cdnUrl={img}
                    style={{ height: "300px" }}
                  /> */}
                </QuickPinchZoom>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </Drawer>
    </div>
  );
}
